define("settings/errors/index", ["exports", "settings/errors/fetch", "settings/errors/credentials", "settings/errors/media-library"], function (_exports, _fetch, _credentials, _mediaLibrary) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "CredentialsMissingPermissionsError", {
    enumerable: true,
    get: function () {
      return _credentials.CredentialsMissingPermissionsError;
    }
  });
  Object.defineProperty(_exports, "CredentialsNotFoundError", {
    enumerable: true,
    get: function () {
      return _credentials.CredentialsNotFoundError;
    }
  });
  Object.defineProperty(_exports, "FetchError", {
    enumerable: true,
    get: function () {
      return _fetch.FetchError;
    }
  });
  Object.defineProperty(_exports, "ImageSizeError", {
    enumerable: true,
    get: function () {
      return _mediaLibrary.ImageSizeError;
    }
  });
  Object.defineProperty(_exports, "MediaSizeError", {
    enumerable: true,
    get: function () {
      return _mediaLibrary.MediaSizeError;
    }
  });
  Object.defineProperty(_exports, "MediaUploadError", {
    enumerable: true,
    get: function () {
      return _mediaLibrary.MediaUploadError;
    }
  });
  Object.defineProperty(_exports, "NetworkError", {
    enumerable: true,
    get: function () {
      return _fetch.NetworkError;
    }
  });
  Object.defineProperty(_exports, "RequestError", {
    enumerable: true,
    get: function () {
      return _fetch.RequestError;
    }
  });
  Object.defineProperty(_exports, "ServerError", {
    enumerable: true,
    get: function () {
      return _fetch.ServerError;
    }
  });
  Object.defineProperty(_exports, "UpgradeMediaSizeError", {
    enumerable: true,
    get: function () {
      return _mediaLibrary.UpgradeMediaSizeError;
    }
  });
});